import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { BlService } from 'src/app/_services/bl/bl.service';
import { LoteService } from 'src/app/_services/lote/lote.service';
import { ScaleTicketService } from 'src/app/_services/scale-ticket/scale-ticket.service';
import { BlDetails } from 'src/app/interfaces/bl.interfaces';
import { SalidaCatalogo, LocationInterface, TranportLine } from 'src/app/interfaces/lotes.interfaces';
import { OriginTicket } from 'src/app/interfaces/scale-ticket.interfaces';
/**
 * Componente de página que gestiona el registro de entradas de un lote de cabotaje,
 * cargando los catálogos necesarios y alternando entre los tipos de entrada.
 */
@Component({
  selector: 'app-cabotaje-lote-entrada',
  templateUrl: './cabotaje-lote-entrada.component.html',
  styles: [`
    .container-button {
      display: flex;
      justify-content: center;
    }

    .subtitle {
      grid-column: 1 / -1;
    }

    .subtitle button {
      color: #fff;
      background-color: #455660;
    }

    .subtitle button:hover {
      color: #455660;
      background-color: #fff;
    }

    .table-header {
      width: 100%
    }

    .detalle-salida {
      position: absolute;
      z-index: 3;
      left: 25%;
      top: 20vh;
      width: 50%;
      height: auto;
      max-height: 80vh;
      padding: 30px 30px 0 30px;
      overflow: auto;
      background-color: #ffffff;
    }

    .container-button {
      margin: 26px 0 50px 0;
    }

    .formTransport {
      grid-template-columns: repeat(2, 1fr);
    }

    .formCreateTransport {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 2;
    }
  `]
})
export class CabotajeLoteEntradaComponent implements OnInit {
  tipoEntrada: string = '1';
  loader: boolean = true;
  tipoTransporte: SalidaCatalogo[] = [];
  tipoUnidad: SalidaCatalogo[] = [];
  locations: LocationInterface[] = [];
  listTransportLine: TranportLine[] = [];
  entriesType: TranportLine[] = [];
  originsTicket: OriginTicket[] = [];
  overlayError: boolean = false;
  operation_number: number = 0;
  blDetails: BlDetails = {
    operation_number:     0,
    boats_name:           '',
    operation_type_number:0,
    bl_tonnage:           0,
    customer_name:        null,
    date_time_capture:    '',
    dock_name:            '',
    port_origin_name:     '',
    start_operations:     '',
    end_operations:       '',
    boat_nationality:     '',
    destination_port:     '',
    operation_id:         0,
    docking_date:         '',
    undocking_date:       '',
    bl_master:            '',
    notice_of_readiness:  '',
    remaining_tonnage:    0,
    output_total_tonnage: 0,
    operation_type:       '',
  };

  constructor(
    private router: Router,
    private loteService: LoteService,
    private blServices: BlService,
    private scaleTicketSvc: ScaleTicketService
  ) { }

  ngOnInit(): void {
    if (this.router.url.includes('ship-list')) {
      const currentUrl = this.router.url;
      const match = currentUrl.match(/\/ship-list\/(\d+)/);
      if (match) {
        this.operation_number = Number(match[1]);
      } else {
        this.loader = false;
        this.overlayError = true;
      }

      this.blServices.getBlId(this.operation_number)
      .subscribe({
        next: (bldetails) => {
          if (!Array.isArray(bldetails) || !bldetails.length) {
            this.loader = false;
            this.overlayError = true;
            return;
          }
          this.blDetails = bldetails[0];
          this.getDataForEntries();
        },
        error: (e) => {
          this.loader = false;
          this.overlayError = true;
        },
      });
    } else {
      this.getDataForEntries();
    }
  }

  /**
   * Carga en paralelo los catálogos requeridos para el registro de entradas (tipos de transporte,
   * unidades, ubicaciones, líneas de transporte, tipos de entrada y orígenes de ticket).
   */
  getDataForEntries() {
    forkJoin([
      this.loteService.getTipoTransporte(),
      this.loteService.getTipoUnidad(),
      this.loteService.getLocations(),
      this.loteService.getListTransportLine(),
      this.loteService.getListEntriesType(),
      this.scaleTicketSvc.getOriginsTicket(),
    ]).subscribe({
      next: ([
        tipoTransporte,
        tipoUnidad,
        locations,
        listTransportLine,
        entriesType,
        originsTicket
      ]) => {
        this.tipoUnidad = this.sortArray<SalidaCatalogo>(tipoUnidad, 'description');
        this.locations = this.sortArray<LocationInterface>(locations, 'description');
        this.listTransportLine = this.sortArray<TranportLine>(listTransportLine, 'description');
        this.entriesType = this.sortArray<TranportLine>(entriesType, 'description');
        this.originsTicket = this.sortArray<OriginTicket>(originsTicket, 'description');
        if (this.router.url.includes('ship-list')) {
          tipoTransporte = tipoTransporte.filter(item => item.id === 2); // Only show ship
        } else {
          tipoTransporte = tipoTransporte.filter(item => item.id !== 2); // Only truck and railway
        }
        this.tipoTransporte = this.sortArray<SalidaCatalogo>(tipoTransporte, 'description');
        this.loader = false;
      },
      error: (e) => {
        this.loader = false;
        this.overlayError = true;
      },
    });
  }

  /**
   * Actualiza el tipo de entrada seleccionado.
   * @param tipo - Identificador del tipo de entrada seleccionado.
   */
  changeEntry(tipo: string) {
    this.tipoEntrada = tipo;
  }

  /**
   * Ordena un arreglo de manera ascendente según la clave indicada.
   * @param array - Arreglo de elementos a ordenar.
   * @param key - Clave del elemento por la cual se ordena.
   * @returns El arreglo ordenado.
   */
  sortArray<T>(array: T[], key: keyof T): T[] {
    return array = array.sort(function (a, b) {
      if (a[key] > b[key]) {
        return 1;
      }
      if (a[key] < b[key]) {
        return -1;
      }
      return 0;
    });
  }
}
